const SocketEvent = Object.freeze({
  Connected: 'connected',
  JoinRoom: 'join_room',
  SendMessage: 'send_message',
  Notification: 'eoffice_notification',
  Export: 'eoffice_export',
  ImportStep3: 'eoffice_import_step_3',
  ImportStep4: 'eoffice_import_step_4',
})

export { SocketEvent }